import React from 'react'
import { Todo } from './Todo'

const CreateTask = () => {
    return (
        <div>
            <Todo/>
        </div>
    )
}

export default CreateTask
